export enum AlertTypeEnum {
    ERROR = 'danger',
    WARN = 'warning',
    SUCCESS = 'success',
    INFO = 'info'
}